<template>
  <b-table
    :items="items"
    :fields="fields"
  >
    <template #cell(jumlah)="data">
      {{ Number(data.value) | formatAmount }}
    </template>
    <template #cell(sisa)="data">
      {{ Number(data.value) | formatAmount }}
    </template>
    <template #cell(keterangan)="data">
      <span v-if="Number(data.value) === 0">
        Lunas
      </span>
      <span v-else>
        Belum Lunas
      </span>
    </template>
  </b-table>
</template>

<script>
import {
  BTable,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
  },
  props: {
    items: {
      type: '',
    },
    fields: {
      type: '',
    },
  },
}
</script>
